const t = "styles-module__textInput___bUEtp", e = "styles-module__error___HDdL6", r = {
  textInput: t,
  error: e
};
export {
  r as default,
  e as error,
  t as textInput
};
